import { render } from "./CustomizeMenu.vue?vue&type=template&id=1486fb85&scoped=true"
import script from "./CustomizeMenu.vue?vue&type=script&lang=js"
export * from "./CustomizeMenu.vue?vue&type=script&lang=js"

import "./CustomizeMenu.vue?vue&type=style&index=0&id=1486fb85&scoped=true&lang=css"
import "./CustomizeMenu.vue?vue&type=style&index=1&id=1486fb85&scoped=true&lang=scss"
import "./CustomizeMenu.vue?vue&type=style&index=2&id=1486fb85&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1486fb85"]])

export default __exports__